import TiptapEditor from '@/components/Editor/TiptapEditor';
import { useToast } from "@/components/ui/use-toast";
import { useAuth } from "@/context/AuthContext";
import { useDebounce } from '@/hooks/useDebounce';
import { useEffect, useState } from 'react';

export default function TaskDescription({ task, onTaskChange, editorRef, isLoading }) {


    // Early return loading state
    if (isLoading) {
        return (
            <div className="py-4 space-y-4">
                <div className="h-5 bg-muted animate-pulse rounded-md w-3/4" />
                <div className="h-5 bg-muted animate-pulse rounded-md w-full" />
                <div className="h-5 bg-muted animate-pulse rounded-md w-2/3" />
                <div className="h-5 bg-muted animate-pulse rounded-md w-1/2" />
            </div>
        );
    }

    const { axiosInstance } = useAuth();
    const { toast } = useToast();

    const [description, setDescription] = useState(task?.description || null);
    const debouncedDescription = useDebounce(description, 1000);

    const handleDescriptionUpdate = async (newContent) => {
        try {
            const { data: updatedTask } = await axiosInstance.patch(
                `/tasks/${task.organization.slug}/${task.key}`, 
                { description: newContent }
            );
            onTaskChange(updatedTask);
            toast({
                description: "Description saved successfully"
            });
        } catch (error) {
            toast({
                description: "Failed to update description",
                variant: "destructive"
            });
            setDescription(task.description);
        }
    };

    useEffect(() => {
        if (
            debouncedDescription && 
            JSON.stringify(task?.description) !== JSON.stringify(debouncedDescription)
        ) {
            handleDescriptionUpdate(debouncedDescription);
        }
    }, [debouncedDescription]);

    return (
        <div>
            <TiptapEditor
                ref={editorRef}
                content={description}
                placeholder="Add description..."
                withMentions
                withCodeBlocks
                withBubbleMenu
                withS3Images
                withS3Uploads
                organizationSlug={task.organization.slug}
                taskKey={task.key}
                onUpdate={({ editor }) => {
                    const json = editor.getJSON();
                    setDescription(json);
                }}
                onEditorReady={(editor) => {
                    editorRef.current = editor;
                }}
            />
        </div>
    );
}